import {
  Element,
  InstallSpec,
  ItemComponent,
  Option,
} from "../../../install/types.ts";

export const SplunkStackComponents = InstallSpec({
  base: ItemComponent({
    label: "Splunk Stack",
    type: "generated",
    hidden: true,
    maturity: "ga",
    schema: {},
  }),
  "iam-write": ItemComponent({
    label: "IAM management",
    description:
      "Allows P0 to manage access to your Splunk Stack UI for your users via manifest-driven configuration.",
    type: "string",
    maxItems: 1,
    maturity: "ga",
    schema: {
      service: Element({
        label: "Service provider",
        description:
          "The service provider hosting the external function to call",
        type: "select",
        default: "aws",
        options: {
          aws: Option({
            key: "aws",
            label: "AWS",
            schema: {
              lambda: Element({
                label: "Function Caller",
                description:
                  "Select the AWS Lambda function to invoke for this integration",
                type: "dynamic",
              }),
            },
          }),
          // Future: Add Azure, GCP support
          azure: Option({
            key: "azure",
            label: "Azure",
            schema: {
              service: Element({
                label: "Function Caller",
                description:
                  "Select the Azure Function to invoke for this integration",
                type: "dynamic",
              }),
            },
          }),
          gcp: Option({
            key: "gcp",
            label: "GCP",
            schema: {
              cloudRun: Element({
                label: "Function Caller",
                description:
                  "Select the GCP Cloud Run service to invoke for this integration",
                type: "dynamic",
              }),
            },
          }),
        },
      }),
    },
  }),
});
